const THEME_STORAGE_KEY = 'app_theme';
const THEME_DARK = 'dark';
const THEME_LIGHT = 'light';

function saveTheme(theme) {
    const expiry = new Date();
    expiry.setFullYear(expiry.getFullYear() + 1);
    document.cookie = THEME_STORAGE_KEY + '=' + theme + ';path=/;expires=' + expiry.toUTCString() + ';SameSite=Lax';
}

function applyTheme(theme) {
    const $btn = $('[data-theme-toggle]');

    if (theme === THEME_LIGHT) {
        $('body').addClass('theme-light');
        $btn.attr('aria-pressed', 'true').attr('title', 'Switch to dark theme');
    } else {
        $('body').removeClass('theme-light');
        $btn.attr('aria-pressed', 'false').attr('title', 'Switch to light theme');
    }
}

window.initTheme = function () {
    // Body class is already set server-side from the cookie — just sync the button state.
    const isLight = $('body').hasClass('theme-light');
    applyTheme(isLight ? THEME_LIGHT : THEME_DARK);
};

$(document).on('click', '[data-theme-toggle]', function () {
    const isLight = $('body').hasClass('theme-light');
    const newTheme = isLight ? THEME_DARK : THEME_LIGHT;
    applyTheme(newTheme);
    saveTheme(newTheme);
});
